import {db} from "@/main";
import {FirestoreDataConverter, collection, collectionGroup, query, where, getDocs, setDoc, doc, getDoc} from "firebase/firestore";

const employDataConverter: FirestoreDataConverter<EmployData> = {
    toFirestore(data: EmployData) {
        return data; 
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            ...data,
            last_update: data.last_update?.toDate() ?? null,
            ttl: data.ttl?.toDate() ?? null,
            valid_to: data.valid_to?.toDate()  ?? null,
            valid_from: data.valid_from?.toDate()  ?? null,
        } as EmployData;
    }
};

const employVacationDataConverter: FirestoreDataConverter<EmployVacationData> = {
    toFirestore(data: EmployVacationData) {
        return data;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            ...data,
            last_update: data.last_update?.toDate() ?? null,
            date: data.date?.toDate() ?? null,
        } as EmployVacationData;
    }
}

const employServiceDataConverter: FirestoreDataConverter<EmployServiceData> = {
    toFirestore(data: EmployServiceData) {
        return data;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            ...data,
            last_update: data.last_update?.toDate() ?? null,
        } as EmployServiceData;
    }
}

export async function GetEmployData(adacount: string): Promise<EmployData> {
    return new Promise<EmployData>(async (resolve, reject) => {

        const employDataRef = collection(db, "employ").withConverter(employDataConverter);

        const employDataQuery = query(
            employDataRef
        );

        const querySnapshot =  await getDocs(employDataQuery);
        const results = querySnapshot.docs.map(doc => doc.data());
        
        const filteredResults = results.filter(employee => employee.adacount?.toLowerCase() === adacount?.toLowerCase());
        
        if(filteredResults.length > 0) {
            resolve(filteredResults[0] as EmployData);
        }
        else
        {
            reject("No such document!");
        }
    });
}

export async function GetEmployDataByEmpNr(employNr: string): Promise<EmployData> {
    return new Promise<EmployData>(async (resolve, reject) => {

        const employDataRef = collection(db, "employ").withConverter(employDataConverter);

        const employDataQuery = query(
            employDataRef
        );

        const querySnapshot =  await getDocs(employDataQuery);
        const results = querySnapshot.docs.map(doc => doc.data());

        const filteredResults = results.filter(employee => employee.emplno?.toLowerCase() === employNr?.toLowerCase());

        if(filteredResults.length > 0) {
            resolve(filteredResults[0] as EmployData);
        }
        else
        {
            reject("No such document!");
        }
    });
}

export function GetEmployDatas(): Promise<EmployData[]> {
    return new Promise<EmployData[]>(async (resolve, reject) => {
        try {
            const employDataRef = collection(db, "employ").withConverter(employDataConverter);
            const employData: EmployData[] = [];

            getDocs(employDataRef)
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        employData.push(doc.data());
                    });
                    resolve(employData);
                })
                .catch((error) => {
                    reject(`Error fetching employData: ${error}`);
                });

        } catch (error) {
            reject(error);
        }
    })}

export function GetEmployVacationData(emplno:string): Promise<EmployVacationData[]> {
    return new Promise<EmployVacationData[]>(async (resolve, reject) => {
        try {
            const employDataRef = doc(db, "employ", emplno).withConverter(employDataConverter);

            getDoc(employDataRef).then((doc) => {
                if (doc.exists()) {
                    let returnEmployVacationData:EmployVacationData[] = [];
                    const employVacationDataColRef = collection(doc.ref, "vacation").withConverter(employVacationDataConverter);
                    getDocs(employVacationDataColRef)
                        .then((employVacationDataSnapshot) => {
                            employVacationDataSnapshot.forEach((doc) => {
                                returnEmployVacationData.push(doc.data() as EmployVacationData);
                            });
                        })
                        .catch((error) => {
                            reject(`Error fetching Employ Vacation Data: ${error}`);
                        }).finally(() => {
                        resolve(returnEmployVacationData);
                    });
                } else {
                    reject("No matching Employ Vacation Data found!");
                }
            });
        } catch (error) {
            reject(error);
        }
    })}

export function GetEmployServiceData(emplno:string): Promise<EmployServiceData[]> {
  return new Promise<EmployServiceData[]>(async (resolve, reject) => {
    try {
      const employDataRef = doc(db, "employ", emplno).withConverter(employDataConverter);

      getDoc(employDataRef).then((doc) => {
        let returnEmployServiceData:EmployServiceData[] = [];
          if (doc.exists()) {
              const employServiceDataColRef = collection(doc.ref, "service").withConverter(employServiceDataConverter);
              getDocs(employServiceDataColRef)
                  .then((employServiceDataSnapshot) => {
                      employServiceDataSnapshot.forEach((doc) => {
                          returnEmployServiceData.push(doc.data() as EmployServiceData);
                      });
                  })
                  .catch((error) => {
                      reject(`Error fetching Employ Service Data: ${error}`);
                  }).finally(() => {
                  resolve(returnEmployServiceData);
              });
          } else {
            resolve(returnEmployServiceData);
              //reject("No matching Employ Service Data found!");
          }
      });
    } catch (error) {
      reject(error);
    }
  })}

export function GetEmployServiceDataDate(emplno:string, from:string, to:string): Promise<EmployServiceData[]> {
  return new Promise<EmployServiceData[]>(async (resolve, reject) => {
    try {
      const employRef = collectionGroup(db, "service");
      const employDataQuery = query(
        employRef,
        where("emplno", "==", emplno),
        where("date", ">=", from),
        where("date", "<=", to)
      );
      const employDataSnapshot = await getDocs(employDataQuery);
      
      let returnEmployServiceData: EmployServiceData[] = [];
      for (const employData of employDataSnapshot.docs) {
        returnEmployServiceData.push(employData.data() as EmployServiceData);
      }
      if (returnEmployServiceData.length === 0) {
        //reject("No matching Employ Service Data found!");
      }
      
      resolve(returnEmployServiceData);
    } catch (error) {
      reject(error);
    }
  })
}

export function GetEmployVacationDataDate(emplno:string, from:string, to:string): Promise<EmployVacationData[]> {
  return new Promise<EmployVacationData[]>(async (resolve, reject) => {
    try {
      const employRef = collectionGroup(db, "vacation");
      const employDataQuery = query(
        employRef,
        where("emplno", "==", emplno),
        where("date_str", ">=", from),
        where("date_str", "<=", to)
      );
      const employDataSnapshot = await getDocs(employDataQuery);
      
      let returnEmployVacationData: EmployVacationData[] = [];
      for (const employData of employDataSnapshot.docs) {
        returnEmployVacationData.push(employData.data() as EmployVacationData);
      }
      if (returnEmployVacationData.length === 0) {
        //reject("No matching Employ Vacation Data found!");
      }
      
      resolve(returnEmployVacationData);
    } catch (error) {
      reject(error);
    }
  })
}

export function SetEmployData(employData: EmployData): Promise<void> {
    return setDoc(doc(db, "employ", employData.emplno), employData, { merge: true })}